export function CaseSubmission(model = {}) {
  return {
    insuredName: model?.insuredName || "",
    policyNumber: model?.policyNumber || "",
    description: model?.description || "",
    documents: model?.documents || []
  };
}
